import React from "react";
import {
  jetwing_logo_img,
  esoft_logo_img,
  nolimit_logo_img,
} from "../Constants/Data";

const logos = [
  { src: jetwing_logo_img, alt: "Jetwing" },
  { src: esoft_logo_img, alt: "Esoft" },
  { src: nolimit_logo_img, alt: "Nolimit" },
];

function OfficialPartners() {
  // duplicate enough times so loop feels infinite on wide screens
  const trackItems = [...logos, ...logos, ...logos, ...logos];

  return (
    <section className="px-[16px] md:px-[24px] py-[40px] md:py-[92px]">
      <div className="container mx-auto">
        <div className="flex flex-col lg:flex-row items-start lg:items-center gap-6 md:gap-10 lg:gap-[60px] w-full justify-between">
          {/* Title */}
          <div className="text-[#B72828] font-medium italic shrink-0">
            <h2 className="text-[20px] md:text-[28px] lg:text-[32px] leading-tight">
              OFFICIAL PARTNERS
            </h2>
          </div>

          {/* Marquee wrapper */}
          <div className="partners-wrapper w-full">
            <div className="partners-track">
              {trackItems.map((logo, i) => (
                <div
                  key={i}
                  className="flex items-center justify-center border border-[#b822223b]
                             w-[110px] h-[64px]
                             sm:w-[122px] sm:h-[70px]
                             md:w-[176px] md:h-[88px]
                             rounded-[8px] shrink-0 bg-transparent"
                >
                  <img
                    src={logo.src}
                    alt={logo.alt}
                    className="max-w-[75%] max-h-[75%] object-contain"
                    loading="lazy"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default OfficialPartners;